import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LazyLoadEvent, MenuItem } from 'primeng/api';
import { finalize } from 'rxjs/operators';
import { AppComponentBase, PagedTableSummary } from 'src/app/app-component-base';
import {
    CitaForListResponse,
    CitasServiceProxy,
    CitaProgramadaNoOtorgadaGetListQuery
} from '../../../../shared/service-proxies/service-proxies';
import { DateTimeService } from '../../../../shared/services/datetime.service';
import { FormService } from '../../../../shared/services/form.service';

@Component({
    templateUrl: './citasnootorgadas.component.html',
    styleUrls: ['../../../../assets/css-custom/p-datatable-general.scss']
})
export class CitasNoOtorgadasComponent extends AppComponentBase implements OnInit {

    @ViewChild('dt1', { static: false }) table;

    form: FormGroup;
    fieldLabels: any = {};

    data: CitaForListResponse[];
    pagedTableSummary: PagedTableSummary = new PagedTableSummary();

    cols: any[];
    selectedItem: any;
    items: MenuItem[];
    query: CitaProgramadaNoOtorgadaGetListQuery = new CitaProgramadaNoOtorgadaGetListQuery();

    browserStorageTableKey: string;
    browserStorageTableFilterKey = 'table-citasnootorgadas-filters';

    permissions: any;

    constructor(
        injector: Injector,
        private formBuilder: FormBuilder,
        private router: Router,
        private service: CitasServiceProxy,
        private dateTimeService: DateTimeService,
        private formService: FormService
    ) {
        super(injector);
    }

    //   aconvenience getter for easy access to form fields
    get f() {
        return this.form.controls;
    }

    get dtService() {
        return this.dateTimeService;
    }

    ngOnInit() {
        const self = this;

        self.browserStorageTableKey = self.browserStorageService.calculateKey('table-citasnootorgadas');

        // Asigno los filtro guardados en localStorage
        const filters: any = self.getFilters(self.browserStorageTableFilterKey);

        self.form = self.formBuilder.group({
            filterText: [null],
            tipo: [1]
        });

        self.setColumns();
        self.getList();
    }

    setColumns(): void {
        const self = this;

        self.cols = self.getDefaultColumns();
    }

    getDefaultColumns(): any[] {
        const self = this;

        return [
            { field: 'fechaCita', header: this.l('Procesos.SesionesHD.Citas.Fecha.Col'), isActive: true },
            { field: 'tipoInstitucion', header: this.l('Procesos.SesionesHD.Citas.TipoInstitucion.Col'), isActive: true },
            { field: 'idee', header: this.l('Procesos.SesionesHD.Citas.IDEE.Col'), isActive: true },
            { field: 'nombrePaciente', header: this.l('Procesos.SesionesHD.Citas.Paciente.Col'), isActive: true },
            { field: 'estatusDesc', header: this.l('Procesos.SesionesHD.Citas.Estatus.Col'), isActive: true }
        ];
    }

    filterSearch(event: any): void {
        const self = this;

        event.preventDefault();

        self.browserStorageService.remove(self.browserStorageTableKey);
        self.table.reset();
        self.query.pageNumber = 1;
    }

    getList(): void {
        const self = this;

        self.query.filter = self.f.filterText.value;
        self.query.tipo = self.f.tipo.value;

        self.service.getCitasProgramadasNoOtorgadasList(self.query)
            .pipe(finalize(() => {
            }))
            .subscribe(data => {

                /// / Aunque en la bd ya están marcadas como NO OTORGADAS, aquí se deben presentar como "PROGRAMADAS"
                // for (let i = 0, len = data.items.length; i < len; i++) {
                //    data.items[i].estatusCitaClave = 'PROG';
                // }

                self.data = data.items;

                // Calculate paged table summary
                self.pagedTableSummary = self.getPagedTableSummay(data.totalCount, self.query.pageNumber, self.query.pageSize);
            });
    }

    loadData(event: LazyLoadEvent) {
        const self = this;

        if (event.sortField) {
            self.query.sorting = event.sortField + ' ' + (event.sortOrder === 1 ? 'ASC' : 'DESC');
        } else {
            self.query.sorting = '';
        }

        self.query.pageNumber = 1 + (event.first / event.rows);
        self.query.pageSize = event.rows;

        self.getList();
    }
}
